import { useTranslation } from 'react-i18next';

export default function PersonalSection() {
	const { t } = useTranslation('profile');

	return (
		<div className="profile-page__card">
			<h3>{t('personal.title')}</h3>
			<div className="profile-page__grid">
				<label>
					{t('personal.firstName')}
					<input type="text" defaultValue={t('personal.defaultValues.firstName')} />
				</label>
				<label>
					{t('personal.lastName')}
					<input type="text" defaultValue={t('personal.defaultValues.lastName')} />
				</label>
				<label>
					{t('personal.email')}
					<input type="email" defaultValue={t('personal.defaultValues.email')} />
				</label>
			</div>
		</div>
	);
}